import { ErrorResponse, StoredFile, type FileKind } from '@deizi/shared';
import { API_BASE, ApiClientError, csrfHeaders } from './api';

export const fileContentUrl = (id: string) => `${API_BASE}/files/${id}/content`;

/**
 * Uploads one file (`POST /files?kind=`), reporting progress from 0 to 1. Uses XHR because
 * fetch cannot report upload progress.
 */
export function uploadFile(
  file: File,
  kind: FileKind,
  onProgress?: (fraction: number) => void,
): Promise<StoredFile> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API_BASE}/files?kind=${kind}`);
    xhr.withCredentials = true;
    xhr.setRequestHeader('accept', 'application/json');
    for (const [k, v] of Object.entries(csrfHeaders())) xhr.setRequestHeader(k, v);
    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) onProgress?.(e.loaded / e.total);
    });
    xhr.addEventListener('error', () =>
      reject(new ApiClientError(0, 'network_error', 'Sem conexão com o servidor.')),
    );
    xhr.addEventListener('load', () => {
      let json: unknown;
      try {
        json = JSON.parse(xhr.responseText);
      } catch {
        json = undefined;
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        const parsed = StoredFile.safeParse(json);
        if (parsed.success) resolve(parsed.data);
        else reject(new ApiClientError(xhr.status, 'internal_error', 'Resposta inesperada'));
        return;
      }
      const err = ErrorResponse.safeParse(json);
      reject(
        err.success
          ? new ApiClientError(
              xhr.status,
              err.data.error.code,
              err.data.error.message,
              err.data.error.details,
            )
          : new ApiClientError(xhr.status, 'internal_error', `HTTP ${xhr.status}`),
      );
    });
    const form = new FormData();
    form.append('file', file, file.name);
    xhr.send(form);
  });
}
